
import ListEmpleadosImpl from 'components/empleados/ListEmpleadosImpl'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewEmpleados = () => {
  return (<Row>
    <Col>
     
      <ListEmpleadosImpl></ListEmpleadosImpl>
      
    </Col>
  </Row>
  )
}

export default ViewEmpleados